"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkVariants = checkVariants;

var _checks = require("../../checks");

var _formatErrors = _interopRequireDefault(require("../../utilities/formatErrors"));

var _copyContent = _interopRequireDefault(require("../../data/copyContent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
*  Checks Experiment Variants
*  Expected GQL Shape:
*
*  experiment(id: $id) {
      variants {
        name
        description
        displayOrder
      }
    }
*/
function checkVariants(experiment) {
  const {
    variants,
    isCmsExperiment
  } = experiment;
  const {
    variants: {
      missingTitle,
      missingDescription,
      missingContent
    }
  } = _copyContent.default;
  const checks = variants.reduce((accumulator, variant) => {
    const {
      name,
      content,
      description,
      displayOrder
    } = variant;

    if (displayOrder === 0 && !isCmsExperiment) {
      accumulator['control__name'] = (0, _checks.checkString)(name, missingTitle);
      accumulator['control__description'] = (0, _checks.checkString)(description, missingDescription);
    } else if (!isCmsExperiment) {
      accumulator[`variant ${displayOrder}__name`] = (0, _checks.checkString)(name, missingTitle);
      accumulator[`variant ${displayOrder}__description`] = (0, _checks.checkString)(description, missingDescription);
    } else if (displayOrder === 0 && isCmsExperiment) {
      accumulator['control__name'] = (0, _checks.checkString)(name, missingTitle);
      accumulator['control__content'] = (0, _checks.checkString)(content, missingContent);
    } else {
      accumulator[`variant ${displayOrder}__name`] = (0, _checks.checkString)(name, missingTitle);
      accumulator[`variant ${displayOrder}__content`] = (0, _checks.checkString)(content, missingContent);
    }

    return accumulator;
  }, {});
  const errors = (0, _formatErrors.default)(checks);
  return {
    checks,
    errors
  };
}